import {
  campaignStatesFilter,
  dataRepresentationEnum,
  MatchTypesEnumType,
} from "../../../types/customers"
import { IVideoMetrics } from "./types"

export interface IPlacementData {
  acos: number
  audienceId: string
  old_audienceId?: string
  bidStrategy: string
  campaignId: number
  clicks: number
  conversion: number
  cpc: number
  ctr: number
  cvr: number
  impressions: number
  newKeywordBid: number
  orders: number
  placement: string
  placementModifier: number
  roas: number
  sales: number
  spend: number
  targetCPCAmazon?: number
  targetAcos: number
  targetCVRCPC: number
  units: number
  bestCVRCPC: number
  oldCPC: number
  adGroupId?: string
  adId?: string
  adExtensionId?: string
  renderedAssetId?: string
  renderedCoverImageUrl?: string
  extensionModerationStatus?: string
  videoMetrics?: IVideoMetrics
}

export type TargetAcosMode = "fixed" | "dynamic" | "fixed-low-volume" | "fixed-ladder"

export interface IPlacementDataTable extends IPlacementData {
  targetAcosMode?: TargetAcosMode
  marketPurchases4w?: number | null
  newbidAdjustment?: number
  limitedCPC?: number
  bestCPC?: number | null
  targetCPC?: number
  newBidAdjustment?: number
}

export interface IPlacementSubResult {
  campaignId: string
  placementsData: IPlacementData[]
}

export type filters = {
  campaignState: campaignStatesFilter
  searchValue: string
  matchType: MatchTypesEnumType
  customFilters: string[]
  dataRepresentationType: dataRepresentationEnum
}

export interface ITagCampaign {
  campaignId: number
  teg: campaignTagsEnum
}

export enum campaignTagsEnum {
  "RANKING" = "Ranking",
}

export enum changeOffAmazonSettingsType {
  "MAXIMIZE_REACH" = "MAXIMIZE_REACH",
  "MINIMIZE_SPEND" = "MINIMIZE_SPEND",
}
